var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeechdictionary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.71 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "volume_up_FILL0_wght400_GRAD0_opsz48",
    d: "m15.71,25v-2.21c2.25-.63,4.24-1.98,5.66-3.84,1.45-1.84,2.22-4.11,2.2-6.45,0-4.81-3.22-9.03-7.86-10.29V0c5.87,1.28,10.03,6.5,10,12.5.03,6-4.13,11.22-10,12.5ZM0,16.82v-8.57h5.71L12.86,1.11v22.86l-7.14-7.14H0Zm15,1.71V6.5c1.27.38,2.38,1.19,3.12,2.29.77,1.1,1.17,2.41,1.16,3.75,0,1.33-.4,2.63-1.18,3.71-.75,1.09-1.84,1.9-3.11,2.29h0Zm-4.29-12l-4.04,3.86H2.14v4.29h4.54l4.04,3.89V6.54Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechdictionary);
export default __webpack_public_path__ + "static/media/speechdictionary.cb3d842a8463c42fac71be2fc1b00d6f.svg";
export { ForwardRef as ReactComponent };